import { Address } from "./address";
import { BaseModel } from "./api";

export enum UserRole {
  USER = "USER", //Usuário da plataforma

  DASH_ADMIN = "DASH_ADMIN", //Administrador da plataforma
  DASH_STAFF = "DASH_STAFF", //Operador painel admin
  DASH_ANALYST = "DASH_ANALYST", //Analista painel admin

  STORE_ADMIN = "STORE_ADMIN", //Administrador da loja
  STORE_STAFF = "STORE_STAFF", //Colaborador da loja
}

export enum UserStatus {
  ACTIVE = "ACTIVE", //Usuário ativos e válido
  INACTIVE = "INACTIVE", //Usuário inativo/desativado

  UNCONFIRMED_EMAIL = "UNCONFIRMED_EMAIL", // Aguardando confirmação de email
}

export interface User extends BaseModel {
  id: string;
  role: UserRole;
  status: UserStatus;
  statusChanged: string;
  name: string;
  email: string;
  cpf: string | null;
  receiveEmails: boolean;
  phoneNumber: string;
  birthdate: string;
  mainAddress: (Address & { id: string }) | null;
}
